import { Box, Typography } from "@mui/material";
import InputCheckbox from "../input/inputCheckbox";

interface Props {
    node: any;
    onCheckboxChange: any;
}
const CheckboxTree = (props: Props) => {
    const { node, onCheckboxChange } = props

    const handleCheckboxChange = () => {
        onCheckboxChange(node, !node.permit);
    };
    return (
        <Box sx={{ borderLeft: "3px dotted #026735", paddingLeft: '10px' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><Typography>{node.name}</Typography> <InputCheckbox checked={node.permit}
                onChange={handleCheckboxChange} />
            </Box>
            <Box sx={{ marginLeft: '20px', marginTop: '5px' }}>
                {node.permit && 
                    node.actions?.map((childNode: any) => (
                        <CheckboxTree
                            key={childNode.code}
                            node={childNode}
                            onCheckboxChange={onCheckboxChange}
                        />
                    ))}
            </Box>
        </Box>
    );
};
export default function CheckboxPermission(props: Props) {
    const { node, onCheckboxChange } = props

    return (
        <Box sx={{ padding: '20px', borderTop: "2px solid #026735" }}>
            <CheckboxTree
                key={node.name}
                node={node}
                onCheckboxChange={onCheckboxChange}

            />
        </Box>
    )
}
